import spartaTransportUtility from '@sparta.global.utilities/sparta-transport-utility/dist/es6.js';
import constants from '@sparta.targeted-content.utilities/constants-utility/dist/es6.js';

/* global sparta */

const {
  SHIELD_ENDPOINTS
} = constants;
const DEFAULTS = {
  language: sparta.language || 'en',
  host: spaParams.siteParams.shieldHost,
  endpoint: SHIELD_ENDPOINTS.V1CONTENT
};
const getTypeMismatch = 'Please provide a String or Array';

/**
 * Tests a string to see if it's a valid url
 *
 * @param {String} str url string to test for validity
 * @returns {Boolean} true if valid url, false otherwise
 */
function validURL(str) {
  if (str.indexOf('localhost') !== -1) return true;
  const pattern = new RegExp('^(https?:\\/\\/)?' // protocol
  + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name
  + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
  + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
  + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
  + '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return !!pattern.test(str);
}

/**
 * Shield Transport class for calling shield endpoints
 *
 * @class ShieldTransport
 */
class ShieldTransport {
  /**
   * Creates an instance of ShieldTransport.
   * @param {Object} options instantiation options.
   */
  constructor(options) {
    this.config = {
      ...DEFAULTS,
      ...options
    };
  }

  /**
   * Constructs the shield resource key from the given arguments
   *
   * @param {String} keyString to build into a shieldKey with this instance's language
   * @returns {String} shield key
   */
  constructKey(keyString) {
    if (keyString.startsWith('en.') || keyString.startsWith('es.')) {
      return keyString;
    }
    return `${this.config.language}.${keyString}`;
  }

  /**
   * Constructs and tests validity of urls for calling later
   *
   * @param {Array} urlsArr array of urls to call
   * @param {String} key shield key
   * @returns {void}
   */
  constructUrls(urlsArr, key) {
    const keyString = this.constructKey(key);
    const constructedURL = `${this.config.host}/${this.config.endpoint}?key=${keyString}`;
    if (validURL(constructedURL)) {
      urlsArr.push(constructedURL);
    }
  }

  /**
   * GET the specified files of given type from shield
   *
   * @param {Object} options arguments
   * @returns {Promise} collection of promises
   */
  get(options) {
    const promises = [];
    const urls = [];
    switch (typeof options) {
      case 'object':
        if (Array.isArray(options)) {
          options.forEach(key => {
            this.constructUrls(urls, key);
          });
        } else {
          promises.push(Promise.reject(new Error(getTypeMismatch)));
        }
        break;
      case 'string':
        this.constructUrls(urls, options);
        break;
      default:
        promises.push(Promise.reject(new Error(getTypeMismatch)));
    }
    urls.forEach(url => {
      const promise = new Promise((resolve, reject) => {
        spartaTransportUtility.once({
          dataType: 'json',
          method: 'GET',
          error: err => {
            reject(err);
          },
          success: response => {
            resolve(response);
          },
          url
        });
      });
      promises.push(promise);
    });
    return Promise.all(promises);
  }
}

export { ShieldTransport as default };
